module.exports = __webpack_public_path__ + "img/icon_radio_checked@3x.52b98e00.png";